import React from "react";
import Modal from "react-modal";
import { Trash2, X } from "lucide-react";

import { Can } from "../../context/permissionContext";
import { formatWhen } from "./commentsApi";
import PostPreview from "./PostPreview";

/**
 * One comment, read in full.
 *
 * The table answers "what is there"; this answers "what does it say" — the
 * whole comment rather than a cell's worth of it, next to the post it was
 * left on and the reader who wrote it. Moderation is a judgement about words,
 * and the row is not enough of them to make one.
 */
const Field = ({ label, children }) => (
  <div className="mb-3">
    <div className="text-muted small mb-1">{label}</div>
    <div>{children}</div>
  </div>
);

const CommentDetail = ({ comment, onClose, onDelete }) => (
  <Modal
    isOpen={!!comment}
    onRequestClose={onClose}
    className="modal_body_md"
    overlayClassName="modal_overlay"
  >
    {/* `modal_body_md` is a white panel from the light theme; `box_wrapper`
        is what paints it in the app's own surface colour. Without it the text
        comes out dark-on-white inside a dark dashboard — see Drive's history
        dialog, which wraps its contents the same way. */}
    <div className="box_wrapper">
      <div className="d-flex align-items-start justify-content-between mb-3">
        <div>
          <h5 className="mb-1">Comment</h5>
          <div className="text-muted small">{formatWhen(comment.commentAt)}</div>
        </div>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onClose}
          aria-label="Close"
        >
          <X size={16} />
        </button>
      </div>

      <Field label="What they said">
        <p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>
          {comment.text}
          {comment.editedAt ? (
            <span className="text-muted small"> (edited {formatWhen(comment.editedAt)})</span>
          ) : null}
        </p>
      </Field>

      <Field label="By">
        {comment.authorName || <span className="text-muted">Deleted account</span>}
        {comment.authorEmail ? (
          <div className="text-muted small">{comment.authorEmail}</div>
        ) : null}
      </Field>

      <Field label="On post">
        <PostPreview postId={comment.postId} />
      </Field>

      <div className="d-flex justify-content-end gap-2 mt-4">
        <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
          Close
        </button>
        <Can feature="comments" action="delete">
          <button
            type="button"
            className="btn btn-outline-danger d-flex align-items-center gap-2"
            onClick={onDelete}
          >
            <Trash2 size={16} /> Delete comment
          </button>
        </Can>
      </div>
    </div>
  </Modal>
);

export default CommentDetail;
